<script>
  import { layoutMethods  } from "@/state/helpers";

  /**
   * Department Team List component
   */
  export default {
    page: {
      title: "Department Team List"
    },
    components: {
    },
    computed: {
    },
    data() {
      return {
        title: "Department Team"
      };
    },
    methods: {
      ...layoutMethods
    },
    async mounted(){
      this.changeTitle({title: 'Department Team'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Careers', to: { name: 'Department Team'} },
          { text: 'Department Team', to: { name: 'Department Team'} }
        ]
      });
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-4 col-sm-4">
                            <div class="my-2">
                                <h5 class="card-title text-dark">
                                    <span class="fw-normal ms-lg-2"> 0 </span> Record(s)
                                </h5>
                            </div>
                        </div>
                        <!-- end col record display--> 
                    </div>
                    <!-- end row -->
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>